export default "__VITE_ASSET__oT0fyRhb__"